import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DropZoneComponent from '../../../components/common/DropZone';
import { IMG_SCALE_SIZE } from '../../../utility/constants';
import { BodyText } from '@paypalcorp/pp-react-text';
import { IconButton } from '@paypalcorp/pp-react-icon-button';
import { DeleteIcon } from '@paypalcorp/pp-react-icons';
import { Alert } from '@paypalcorp/pp-react-alert';
import { Message } from '@paypalcorp/worldready-react';
import { trackEventWithData } from '../../utilsV3/analytics';
import { FPTI_SPEC, SCREEN } from '../../utilsV3/fptiConstants';
import BannerCropImage from '../../shared/imageExperience/BannerExperience/BannerCropImage';
import { BTN_FACTORY_V3_FORM } from '../../clientConstants';
import _isEmpty from 'lodash/isEmpty';

const getUrlExtension = (url) => {
  return `image/${url.split(/[#?]/)[0].split('.').pop().trim().toLowerCase()}`;
};

const createImage = (imgUrl) => {
  const image = new Image();
  image.src = imgUrl;
  return image;
};

const DropzoneImageHandle = ({ closeModal, bannerImageUrl, isMobile }) => {
  const [imageData, setImageData] = useState({});
  const [dropzoneError, setDropzoneError] = useState('');
  const [isImageUploaded, setImageUpdated] = useState(false);

  useEffect(() => {
    if (bannerImageUrl) {
      const img = createImage(bannerImageUrl);
      setImageData({
        src: bannerImageUrl,
        name: bannerImageUrl.split('/').pop(),
        height: img.height,
        width: img.width,
        type: getUrlExtension(bannerImageUrl),
      });
    }
  }, []);

  const handleImageDropzone = (image) => {
    setDropzoneError('');
    if (image.hasError) {
      trackEventWithData(FPTI_SPEC.FIELD_LEVEL_ERROR_IM, {
        error_code: 'IMAGE_DROPZONE_ERROR',
        error_desc: 'banner_image',
        error_detail: image.error,
        screen: SCREEN.EXPERIENCE_SETUP,
      });
      setDropzoneError(image.error);
    } else {
      setImageData(image);
      setImageUpdated(true);
      trackEventWithData(FPTI_SPEC.UPLOAD_BACKGROUND_IMG_MODAL_IMAGE_UPDATED);
    }
  };

  return (
    <div className="image-handler">
      {_isEmpty(imageData) ? (
        <>
          <DropZoneComponent
            showPreviewInDropzone={false}
            onChange={handleImageDropzone}
            imgWidth={IMG_SCALE_SIZE.WIDTH_BANNER}
            onlyEditButton={false}
            fptiSpec={{
              updated: FPTI_SPEC.CONFIGURE_BUTTON_PAGE_LOGO_UPDATED,
              change: FPTI_SPEC.CONFIGURE_BUTTON_PAGE_CHANGE_LOGO_CL,
            }}
          />
          {dropzoneError && (
            <Alert type="warning" className="dropzone-error">
              {dropzoneError}
            </Alert>
          )}
        </>
      ) : (
        <>
          <BodyText strong>
            <Message id="buttonsV3.imageBanner.modal.imageHandle" />
          </BodyText>
          <div className="image-name-delete">
            {imageData?.name && (
              <BodyText className="dropzone-image-name">
                {imageData?.name}
              </BodyText>
            )}
            <IconButton
              onClick={() => setImageData({})}
              svgIconComponent={DeleteIcon}
              className={'delete-img'}
            >
              <Message id="buttonsV3.imageBanner.modal.deleteButton" />
            </IconButton>
          </div>

          <BannerCropImage
            imgUrl={imageData?.src}
            closeModal={closeModal}
            imgWidth={imageData?.width}
            imgHeight={imageData?.height}
            isMobile={isMobile}
            form={BTN_FACTORY_V3_FORM}
            name={'bannerImageUrl'}
            isImageUploaded={isImageUploaded}
            imgType={imageData?.type}
          />
        </>
      )}
    </div>
  );
};

DropzoneImageHandle.propTypes = {
  closeModal: PropTypes.func,
  bannerImageUrl: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default DropzoneImageHandle;
